import { Component, AfterViewInit, EventEmitter, Output, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbPanelChangeEvent, NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { UserServices } from '../../appauth/user-pages/user/users.services';
import { Router } from '@angular/router';
import { AuthServices } from '../../appauth/auth/auth.services';
import { localStorageServices } from '../../appauth/auth/localStorageServices';
import { Globals } from '../../global/global.model';
declare var $: any;
@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements OnInit {
  @Output() toggleSidebar = new EventEmitter<void>();

  public config: PerfectScrollbarConfigInterface = {};
  constructor(private modalService: NgbModal,
              private router: Router, 
              public authServices:AuthServices,
              public localdata:localStorageServices,
              private servicesUser:UserServices) {
                this.dataUser=localdata.getValueFromLocalStorage().datos;
              }

  public showSearch = false;
  dataUser:any;
  public imgUrlProfile:string;
  

  // This is for Notifications
  notifications: Object[] = [
    {
      round: 'round-danger',
      icon: 'ti-link',
      title: 'Luanch Admin',
      subject: 'Just see the my new admin!',
      time: '9:30 AM'
    },
    {
      round: 'round-success',
      icon: 'ti-calendar',
      title: 'Event today',
      subject: 'Just a reminder that you have event',
      time: '9:10 AM'
    },
    {
      round: 'round-info',
      icon: 'ti-settings',
      title: 'Settings',
      subject: 'You can customize this template as you want',
      time: '9:08 AM'
    },
    {
      round: 'round-primary',
      icon: 'ti-user',
      title: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:00 AM'
    }
  ];

  // This is for Mymessages
  mymessages: Object[] = [
    {
      useravatar: 'assets/images/users/1.jpg',
      status: 'online',
      from: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:30 AM'
    },
    {
      useravatar: 'assets/images/users/2.jpg',
      status: 'busy',
      from: 'Sonu Nigam',
      subject: 'I have sung a song! See you at',
      time: '9:10 AM'
    },
    {
      useravatar: 'assets/images/users/2.jpg',
      status: 'away',
      from: 'Arijit Sinh',
      subject: 'I am a singer!',
      time: '9:08 AM'
    },
    {
      useravatar: 'assets/images/users/4.jpg',
      status: 'offline',
      from: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:00 AM'
    }
  ];

  //Evento logout

  cerrarSession(){
    console.log("cerrar session");
    
    this.authServices.logout().subscribe( (data:any) => {
      if(data.message.estado){
        this.localdata.removeValueFromLocalStorage();
        this.router.navigate(['login']);
      }
    });
  }

  profile(){
    this.router.navigate(['user-pages/userprofile']);
  }

  imagePhoto(){
    this.router.navigate(['user-pages/photo']);
  }


  home(){
    this.router.navigate(['home']);
  }

  

  ngOnInit() {
    if(this.dataUser.fotousers[0] !== undefined)
      this.imgUrlProfile=Globals.BASE_URL_API_REST+this.dataUser.fotousers[0].dir+this.dataUser.fotousers[0].filename;
      else
        this.imgUrlProfile="assets/images/user.png";
  }

  
}